let serviceInjectors;

try {
	serviceInjectors = com.jacada.common.injector.serviceInjectors;
}catch (e) {}

class ServiceRegistrator {

	registerService(name, serviceInstance) {

		if(serviceInjectors && serviceInjectors.length > 0) {

			for(let serviceInjector of serviceInjectors) {
				serviceInjector.injectService(name, serviceInstance);
			}
		}
	}
}

export let serviceRegistrator = new ServiceRegistrator();


// WEBPACK FOOTER //
// ../common/services/src/serviceRegistrator.js